module.exports = __webpack_public_path__ + "static/media/survey-workflow-status.6f2a01b0.png";